/* eslint-disable */
import React from 'react';
import { css } from 'react-emotion';
import { Box } from '../components/Layout';
import { Link } from '../components/Misc';
import { Footer } from '../components/Footer';
import {Collapse} from 'react-collapse';
import { Line } from 'rc-progress';
import ribbons from '../components/Ribbon/ribbon.module.css'

const LearningObjectives = ({ data }) => {
  var expandedLO;
  function ExpandedLOSectionFxn(lo) {
    const modules = data.allAirtable.edges;
    console.log("hello from fxn");
    let lo_list = "<ul>";
    if(lo.ContentLO1)
    {
      lo.ContentLO1.forEach((e) => {
      /*//console.log(e)
      //console.log(modules);
      console.log(modules.find(({node: mdl}) => {
        //console.log(mdl)
        //console.log(e)
        return (mdl.id === e);
      }).node.Name)
      */
      lo_list += "<li>"+ modules.find(({node: mdl}) => {
        return (mdl.id === e);
      }).node.Name +"</li>";
      })
    }if(lo.ContentLO2)
    {
      lo.ContentLO2.forEach((e) => {
      console.log(e)
      lo_list += "<li>"+ modules.find(({node: mdl}) => {
        return (mdl.id === e);
      }).node.Name +"</li>";
      })      
    }if(lo.ContentLO3)
    {
      lo.ContentLO3.forEach((e) => {
      console.log(e)
      lo_list += "<li>"+ modules.find(({node: mdl}) => {
        return (mdl.id === e);
      }).node.Name +"</li>";
      })
    }
    lo_list+="</ul>";
    return(
      <div className="Container" dangerouslySetInnerHTML={{__html: 
      lo_list}}></div>
      );
  };
  function handleExpandLO(event){
    const target = event.target;
    const name = target.attributes.name.value;
    const modules = data.allAirtable.edges;
    console.log(target.attributes.name.value)
    if(this.state.expandedLO === name)
    {
      expandedLO = "none";
    }
    else
    {
      expandedLO = name;
    }
  }
  const { edges: learningObjectives } = data.allAirtableLearningObjectives;
  return (
    <Box>
    <div className={ribbons.cornerRibbon}>Beta</div> 
      <Box
        width={[1, 1, 1 / 2]}
        m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
        px={[3, 3, 0]}
        style={{ overflow: 'visible' }}
      >
        <h1>Learning Objectives</h1>
        <Box>
          <h3>(not to be confused with <Link to="background#learningoutcomes">learning outcomes</Link>)</h3>
          <p>
            Consider your own rationale for teaching this class. What is important to you about the material? About the way you plan to teach the material? About how the participants interact with the content?
          </p>
          <p>
            Learning objectives represent what you want participants to learn, or even more boldly, what you want them to remember next year, at a very high and abstract level. They are not necessarily directly measurable and may have a very broad impact on your participants. An example of a learning objective would be: "Become familiar with user-centric design". As you would probably agree, this is an important skill to have, but not necessarily directly visible nor measurable. Participants will nevertheless learn to appreciate and use this skill throughout the program and in their future professional life. A more concrete form of learning objectives are the deduced learning outcomes, discussed <Link to="background#learningoutcomes">here</Link>.
          </p>
          <p>
            We understand that every class is different and participants as well as instructors have different priorities when it comes to their learning objectives. With our module catalogue, you will be able to put together a blend of content which will cover those learning objectives you find most important. You will be able to emphasize some of them and dial back on others by selecting or unselecting specific modules.
          </p>
        </Box>
        <h2> The CHIC Learning Objectives</h2>
        <p>
          <ol>
            {
              learningObjectives
              .filter(lo => lo.node.LearningObjective.length > 0)
              .map(({ node: lo }) => {
                return(
                  <li key={lo.id}><b>{lo.LearningObjective}</b>
                    <div 
                      name={"lo"+lo.id}
                      //onMouseEnter={this.handleExpandLO}
                      onClick={handleExpandLO}
                    >
                    </div>
                    <Collapse isOpened={expandedLO === ("lo"+lo.id)}>
                      {ExpandedLOSectionFxn(lo)}
                    </Collapse>
                    
                  </li>
                );
              })
            }
          </ol>
        </p>
      </Box>
    <Footer/> 
    </Box>
  );
};

export const pageQuery = graphql`
  query LOByPath {
    allAirtable(sort: { order: ASC, fields: [order] }) {
      edges {
        node {
          slug
          order
          id
          Name
          Summary
          ModuleContent
          previewImage {
            url
          }
          TimelineLocation
          SuggestedStaff
          InClassDuration
          DurationValueIsPerTeam
          PreparationTime
          LearningObjective1
          LOscore1
          LearningObjective2
          LOscore2
          LearningObjective3
          LOscore3
        }
      }
    }
    allAirtableLearningObjectives(sort: { order: ASC, fields: [Autonumber] }) {
      edges {
        node {
          id
          LearningObjective
          ContentLO1
          ContentLO2
          ContentLO3
          LO1fulfilled
          LO2fulfilled
          LO3fulfilled
          LO1Nreferences
          LO2Nreferences
          LO3Nreferences
        }
      }
    }
  }
`;

export default LearningObjectives;



// WEBPACK FOOTER //
// ./src/pages/learningobjectives.js